// extracted by mini-css-extract-plugin
export default {"root":"T6fxooWDSz","itemsContainer":"EiZkanESyc"};